import PropTypes from 'prop-types'

const KeywordAfter = ({ after }) => (
  <>
    {after.biddingStrategy && (
      <tr>
        <th scope="row">입찰단가</th>
        <td>
          <div className="inner_cell">{after.biddingStrategy}</div>
        </td>
      </tr>
    )}
    {after.landingUrl && (
      <tr>
        <th scope="row">랜딩URL</th>
        <td>
          <div className="inner_cell">{after.landingUrl}</div>
        </td>
      </tr>
    )}
  </>
)
export default KeywordAfter
KeywordAfter.propTypes = {
  after: PropTypes.shape({
    biddingStrategy: PropTypes.string,
    landingUrl: PropTypes.string,
  }),
}
